import ReactGA from "react-ga";
import { ANALYTICS_ID } from "configs/constants";

export const GA_init = (trackingID = ANALYTICS_ID) => {
  ReactGA.initialize(trackingID);
};

export const GA_pageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};

/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 */
export const GA_event = (category: string, action: string, label: string) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};
